import { render, staticRenderFns } from "./Sap.vue?vue&type=template&id=0df8287c"
import script from "./Sap.vue?vue&type=script&lang=js"
export * from "./Sap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports